import { Sun, Moon } from 'lucide-react';

export const ThemeToggleButton = ({ darkMode, onClick }) => (
  <button onClick={onClick} className="p-2.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors text-slate-500 dark:text-slate-400" title="Toggle Theme">
    {darkMode ? <Sun size={20} /> : <Moon size={20} />}
  </button>
);
